import {copyPngToClipboard, PNG_CLIPBOARD_MIMETYPE} from '@Utils/clipboard.util';
import {getUrlForGeneratedAiChatModelAssetsImage} from '@Libraries/ai-chat.library';
import {MediaItemSizeType} from '@Libraries/s3-library';

export const copyAiChatImageToClipboard = (hashedId: string): Promise<void> => {
  return copyPngToClipboard(fetchAiChatImagePng(hashedId));
};

const fetchAiChatImagePng = async (hashedId: string): Promise<Blob> => {
  const response = await fetch(getUrlForGeneratedAiChatModelAssetsImage(hashedId, MediaItemSizeType.HIGH_RES));
  if (!response.ok) {
    throw new Error();
  }

  return new Blob([await response.blob()], {type: PNG_CLIPBOARD_MIMETYPE});
};
